import { createReducer } from '@reduxjs/toolkit';
import {
    setDirectMetrics,
    setDirectCampaigns,
    setDirectCampaignsLoading,
    setDirectCampaignSaving,
    setDirectLogins,
    setDirectLoginsLoading,
} from './actions';
import { DirectMetricsUI, DirectCampaignModel } from './types';

interface DirectState {
    metrics: DirectMetricsUI;
    campaigns: {
        records: Record<number, DirectCampaignModel> | undefined;
        isLoading: boolean;
    };
    isSaving?: boolean;
    logins: {
        items: string[];
        isLoading: boolean;
    };
}

const initialState = {
    metrics: { counters: [], goals: [] },
    campaigns: {
        records: undefined,
        isLoading: false,
    },
    logins: { items: [], isLoading: false },
};

export const directReducer = createReducer<DirectState>(initialState, (builder) => {
    builder
        .addCase(setDirectMetrics, (draft, action) => {
            draft.metrics = action.payload;
        })
        .addCase(setDirectCampaigns, (draft, action) => {
            if (!draft.campaigns.records) {
                draft.campaigns.records = {};
            }
            action.payload.forEach((campaign) => {
                draft.campaigns.records![campaign.id] = campaign;
            });
        })
        .addCase(setDirectCampaignsLoading, (draft, action) => {
            draft.campaigns.isLoading = action.payload;
        })
        .addCase(setDirectCampaignSaving, (draft, action) => {
            draft.isSaving = action.payload;
        })
        .addCase(setDirectLoginsLoading, (draft, action) => {
            draft.logins.isLoading = action.payload;
        })
        .addCase(setDirectLogins, (draft, action) => {
            draft.logins.items = action.payload;
        });
});
